import { render, staticRenderFns } from "./discount-by-range-edit.vue?vue&type=template&id=382a34d6&"
import script from "./discount-by-range-edit.vue?vue&type=script&lang=js&"
export * from "./discount-by-range-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports